import { TrendingUp, TrendingDown } from "lucide-react";

export function Delta({ current, previous }) {
  if (current == null || previous == null) return null;
  if (previous === 0) {
    if (!current) return null;
    return (
      <span className="text-[11px] font-medium text-muted-foreground" title="rispetto al periodo precedente">
        nuovo
      </span>
    );
  }
  const pct = ((current - previous) / Math.abs(previous)) * 100;
  const up = pct >= 0;
  const Icon = up ? TrendingUp : TrendingDown;
  return (
    <span
      title="rispetto al periodo precedente"
      data-testid="delta-badge"
      className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${up ? "text-emerald-400" : "text-rose-400"}`}
    >
      <Icon className="h-3 w-3" />
      {up ? "+" : ""}{pct.toFixed(1)}%
    </span>
  );
}
